import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.tsx";
import Menu from "../../components/layout/Menu.tsx";
import Footer from "../../components/layout/Footer.tsx";
import { onKeyActivate } from "../../utils/a11y.ts";

import { FaBuilding, FaFileAlt, FaHeadset } from "react-icons/fa";
import LoadingSpinner from "../../components/ui/LoadingSpinner.tsx";

const InternalGestao: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return <LoadingSpinner />;

  const modules = [
    {
      title: "Atas de Reuniões",
      description: "Acesse e gerencie as atas de reuniões da empresa",
      icon: <FaFileAlt />,
      path: "/internal/meeting-records",
    },
    {
      title: "Meus Chamados",
      description: "Acompanhe o andamento dos chamados que você abriu",
      icon: <FaHeadset />,
      path: "/internal/meus-chamados",
    },
    {
      title: "Quem Somos",
      description: "Conheça a história da V-CORP e nosso time de colaboradores",
      icon: <FaBuilding />,
      path: "/internal/empresa",
    },
  ];

  return (
    <div className="p-2">
      <Menu />
      <div className="content-area">
        <div className="page-header">
          <h2>Área Interna</h2>
        </div>

        <div className="gestao-modules-grid">
          {modules.map((module, index) => (
            <div
              key={index}
              className="gestao-module-card"
              onClick={() => navigate(module.path)}
              onKeyDown={onKeyActivate(() => navigate(module.path))}
              role="button"
              tabIndex={0}
            >
              <div className="gestao-module-icon">{module.icon}</div>
              <h3>{module.title}</h3>
              <p>{module.description}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default InternalGestao;
